<script>
import { Validator } from 'simple-vue3-validator'
import axios from 'axios';
import useAppRouter from '../../composables/useAppRouter';

export default {
  data() {
    return {
      minPasswordLength: 9,
      serverMessage: '',
      linkAccountMode: false,
      accountAccessToken: null,
      recaptchaVerified: false,
      signupModel: {
        Email: '',
        ConfirmEmail: '',
        Password: '',
        FirstName: '',
        LastName: '',
        DateOfBirth: '',
        ReturnUrl: '',
        IsUserCreatedForNewFundraisingPage: false
      },
      router: useAppRouter,
    }
  },
  watch: {
    signupModel: {
      handler() {
        this.signupModel.ConfirmEmail = this.signupModel.Email;
        this.serverMessage = "";
      },
      deep: true
    }
  },
  methods: {
    async executeRegister(captchaResult) {
      if (this.registerUrl === '/pages/register') {
        const payload = { ...this.signupModel, TuringTest: captchaResult };
        const url = this.returnUrl
          ? this.registerUrl + '?returnUrl=' + encodeURIComponent(this.returnUrl)
          : this.registerUrl;
        return axios.post(url, payload, {
          headers: {
            'Content-Type': 'application/json',
          }
        });
      }

      return axios.post(this.registerUrl, this.signupModel, {
        headers: {
          'Content-Type': 'application/json',
        }
      });
    },
    async submitRegistration() {
      var vm = this;
      var success = await this.$validate()

      if (!success)
        return;

      if (vm.linkAccountMode && vm.accountAccessToken && vm.accountAccessToken.length > 0) {
        vm.signupModel.Provider = "facebook";
        vm.signupModel.Data = vm.accountAccessToken;
      }

      if (vm.registerUrl === '/pages/register' && vm.captchaPublicKey && !vm.recaptchaVerified) {
        vm.executeRecaptcha();
        return;
      }

      return vm.completeRegistration();
    },
    executeRecaptcha() {
      this.$refs.invisibleRecaptcha.execute();
    },
    onRecaptchaVerified(token) {
      this.recaptchaVerified = true;
      this.completeRegistration(token);
    },
    resetRecaptcha() {
      if (this.captchaPublicKey && this.$refs.invisibleRecaptcha)
        this.$refs.invisibleRecaptcha.reset();
    },
    async completeRegistration(captchaResult) {
      var vm = this;
      try {
        var res = await vm.executeRegister(captchaResult);
        vm.$gfLogger.logInfo("Registration response:", res);
        if (res.status === 200 && res.data && !res.data.success) {
          vm.serverMessage = res.data.message;
          vm.recaptchaVerified = false;
          vm.resetRecaptcha();
          if (res.data.showProviderButton && res.data.showProviderButton === true) {
            vm.showFacebookButton = true;
          }
          return;
        }

        if (res.status === 200 && res.data.TempData === undefined) {
          vm.$emit('loggedIn', res.data.userEmail, this.signupModel.IsUserCreatedForNewFundraisingPage);
          return vm.redirectToPage(vm.returnUrl);
        }
        return vm.processServerResponse(res.data)
      }
      catch (err) {
        console.log("Error during registration: " + err);
      }
    },
    processServerResponse: function (data) {
      if (data.TempData["Status.Css"] && data.TempData["Status.Css"].toLowerCase() == "error")
        this.serverMessage = data.TempData["Status.Message"];
    },

    redirectToPage: function (url) {
      if (this.disableRedirect)
        return

      window.location.replace(url);
    }
  },
  validators: {
    'signupModel.Email': function (value) {
      if (!this.linkAccountMode)
        return Validator.value(value)
          .required()
          .email()
          .custom(function () {
            if (value && /['‘’]/.test(value)) {
              return "Email addresses containing apostrophes aren't supported. Please use an alternative email address.";
            }
          });
    },
    'signupModel.Password': function (value) {
      if (!this.linkAccountMode)
        return Validator.value(value).required().minLength(this.minPasswordLength);
    },
    'signupModel.FirstName': function (value) {
      if (!this.linkAccountMode)
        return Validator.value(value).required();
    },
    'signupModel.LastName': function (value) {
      if (!this.linkAccountMode)
        return Validator.value(value).required();
    }
  }
}
</script>
